import React from "react";
import Styles from "./style.module.scss";
import AccordionAdmin from "@Molecule/AccordionAdmin";
import moment from "moment";
import Icon from "@Atom/Icon";
import Button from "@Atom/Button";
import { useNavigate } from "react-router-dom";

export default function AbsenceClassAdmin({ data }) {
  const navigate = useNavigate();
  return (
    <div className={Styles.container}>
      {data.batches.map((el, idx) => (
        <div key={idx}>
          <AccordionAdmin
            head={
              <div className={Styles.accordionHead}>
                <div>
                  <Icon icon={"calendar2"} size={20} color={"#FFFFFF"} />
                </div>
                <div>
                  <p>Batch {idx + 1}</p>
                  <p>
                    {moment(el.date.split("-")[0]).format("DD")} -{" "}
                    {moment(el.date.split("-")[1]).format("DD MMM YYYY")}
                  </p>
                </div>
              </div>
            }
            body={
              <div className={Styles.scheduleBody}>
                {el.sessions.map((session, idxSession) => (
                  <div className={Styles.scheduleCard} key={idxSession}>
                    <div className={Styles.cardHead}>
                      <p>Sesi {idxSession + 1}</p>
                      <p>{moment(session.date).format("DD MMMM YYYY")}</p>
                    </div>
                    <Button
                      variant="outlined"
                      text={"Mulai Proses Absensi"}
                      onClick={() =>
                        navigate(`absence?k=1&s=${idxSession + 1}&b=${idx + 1}`)
                      }
                    />
                  </div>
                ))}
              </div>
            }
          />
        </div>
      ))}
    </div>
  );
}
